/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindCertificateRequestsForSupplierQueryResponse,
  FindCertificateRequestsForSupplierQueryParams,
} from "../types/FindCertificateRequestsForSupplier.ts"

export const findCertificateRequestsForSupplierQueryKey = (
  params?: FindCertificateRequestsForSupplierQueryParams
) =>
  [
    { url: "/v1/certificate-request/find-certificate-requests-for-supplier" },
    ...(params ? [params] : []),
  ] as const

export type FindCertificateRequestsForSupplierQueryKey = ReturnType<
  typeof findCertificateRequestsForSupplierQueryKey
>

/**
 * @summary Find certificate requests for supplier
 * {@link /v1/certificate-request/find-certificate-requests-for-supplier}
 */
export async function findCertificateRequestsForSupplier(
  params?: FindCertificateRequestsForSupplierQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCertificateRequestsForSupplierQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate-request/find-certificate-requests-for-supplier`,
    params,
    ...requestConfig,
  })
  return res
}

export function findCertificateRequestsForSupplierQueryOptions(
  params?: FindCertificateRequestsForSupplierQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findCertificateRequestsForSupplierQueryKey(params)
  return queryOptions<
    ResponseConfig<FindCertificateRequestsForSupplierQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCertificateRequestsForSupplierQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findCertificateRequestsForSupplier(params, config)
    },
  })
}

/**
 * @summary Find certificate requests for supplier
 * {@link /v1/certificate-request/find-certificate-requests-for-supplier}
 */
export function useFindCertificateRequestsForSupplier<
  TData = ResponseConfig<FindCertificateRequestsForSupplierQueryResponse>,
  TQueryData = ResponseConfig<FindCertificateRequestsForSupplierQueryResponse>,
  TQueryKey extends QueryKey = FindCertificateRequestsForSupplierQueryKey,
>(
  params?: FindCertificateRequestsForSupplierQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCertificateRequestsForSupplierQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findCertificateRequestsForSupplierQueryKey(params)

  const query = useQuery(
    {
      ...findCertificateRequestsForSupplierQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
